import { Injectable } from '@angular/core';
import Swal from 'sweetalert2';

@Injectable({
  providedIn: 'root'
})
export class AlertService {
  showSuccess(message: string, title: string) {
    Swal.fire({
      icon: 'success',
      title,
      text: message,
      confirmButtonText: 'OK'
    });
  }

  showError(message: string, title: string) {
    Swal.fire({
      icon: 'error',
      title,
      text: message,
      confirmButtonText: 'OK'
    });
  }

  showWarning(message: string, title: string) {
    Swal.fire({
      icon: 'warning',
      title,
      text: message,
      confirmButtonText: 'OK'
    });
  }
}